import request from '@/api/request.js';

/**
 * 同意审批
 */
export function agree(data) {
    return request({
        url: 'workspace/audit/agree',
        method: 'POST',
        data: data,
    });
}

/**
 * 拒绝审批
 */
export function refuse(data) {
    return request({
        url: 'workspace/audit/refuse',
        method: 'POST',
        data: data,
    });
}

/**
 * 评论申请
 */
export function comments(data) {
    return request({
        url: 'workspace/audit/comments',
        method: 'POST',
        data: data,
    });
}

/**
 * 撤销申请
 */
export function revoke(data) {
    return request({
        url: 'workspace/audit/revoke',
        method: 'POST',
        data: data,
    });
}